import React, { ReactNode } from "react";
import styled from "styled-components/macro";

import { Grid, GridSize } from "@material-ui/core";

import { BoldText, Text } from "components/Text";

export const ReviewCard = styled.div`
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fff;
`;

export const ReviewCardTitle = styled(BoldText)`
  display: block;
  font-size: 16px;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 8px;
`;

export const ReviewFieldGrid = styled(Grid).attrs({
  container: true,
  spacing: 2,
})`
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ReviewFieldLabel = styled(Text)`
  display: block;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 4px;
`;

interface ReviewFieldProps {
  xs?: GridSize;
  label?: ReactNode;
  children?: ReactNode;
}

export const ReviewField = ({ xs = 12, label, children }: ReviewFieldProps) => (
  <Grid item xs={xs}>
    {label != null && <ReviewFieldLabel>{label}</ReviewFieldLabel>}
    <Text fontSize="beta" color="gray40">
      {children}
    </Text>
  </Grid>
);
